import StatusIcons from "./content/outgoing/SubComponents/StatusIcons";
import PositionRow from "./content/outgoing/PositionRow";
import PositionRowHeader from "./content/outgoing/RowHeader";
import BillSummary from "./content/outgoing/BillSummary";
import Address from "./content/outgoing/SubComponents/Address";

const InfoCard = ({ title, children }) => (
  <div style={{
    background: "#fff", borderRadius: "10px", padding: "14px 18px",
    boxShadow: "0 1px 6px rgba(0,0,0,0.07)", marginBottom: "12px",
  }}>
    {title && (
      <div style={{
        fontSize: "0.7rem", fontWeight: 700, textTransform: "uppercase",
        letterSpacing: "0.08em", color: "#9e9e9e", marginBottom: "10px",
      }}>
        {title}
      </div>
    )}
    {children}
  </div>
);

const DateRow = ({ label, value }) => value ? (
  <div style={{ display: "flex", justifyContent: "space-between", padding: "4px 0", fontSize: "0.88rem" }}>
    <span style={{ color: "#9e9e9e" }}>{label}</span>
    <span style={{ fontWeight: 600, color: "#424242" }}>{value}</span>
  </div>
) : null;

const BillOut = ({ bill }) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>

      {/* Top: address + details side by side */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}>
        <InfoCard title="Bill To">
          <Address addressJson={bill.fixed_address} style={{ margin: 0, fontSize: "0.92rem", lineHeight: 1.6 }} />
        </InfoCard>

        <InfoCard title="Details">
          <div style={{ marginBottom: "10px" }}>
            <StatusIcons
              payed={bill.geldeingang}
              draft={bill.draft}
              subscription={bill.aborechnung}
              privateButton={bill.privat}
            />
          </div>
          <DateRow label="Billing date" value={bill.rechungsdatum} />
          <DateRow label="Will be debited" value={bill.faelligkeitsdatum} />
          <DateRow label="Follow up" value={bill.followup} />
        </InfoCard>
      </div>

      {/* Subject + description */}
      {bill.betreff && (
        <InfoCard>
          <div style={{ fontWeight: 700, fontSize: "1rem", color: "#212121", marginBottom: bill.beschreibung ? "8px" : 0 }}>
            {bill.betreff}
          </div>
          {bill.beschreibung && (
            <div style={{ fontSize: "0.9rem", color: "#616161", lineHeight: 1.6 }}>{bill.beschreibung}</div>
          )}
        </InfoCard>
      )}

      {/* Positions table */}
      <div style={{
        background: "#fff", borderRadius: "10px", overflow: "hidden",
        boxShadow: "0 1px 6px rgba(0,0,0,0.07)",
      }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <PositionRowHeader showDropdowns={false} />
          <tbody>
            {bill.positionen.map((position, index) => (
              <PositionRow
                key={index}
                index={index}
                position={position}
                showDropdowns={false}
              />
            ))}
          </tbody>
        </table>
      </div>

      {/* Footer: post text + summary */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", alignItems: "start" }}>
        {bill.post_text ? (
          <InfoCard>
            <div style={{ fontSize: "0.88rem", color: "#616161", lineHeight: 1.6 }}>{bill.post_text}</div>
          </InfoCard>
        ) : <div />}
        <BillSummary positionen={bill.positionen} />
      </div>

    </div>
  );
};

export default BillOut;
